import React, { useEffect } from 'react';
import { Hero } from '../components/MenteEnSilencio/Hero';
import { Stats } from '../components/MenteEnSilencio/Stats';
import { HeroTestimonials } from '../components/MenteEnSilencio/HeroTestimonials';
import { PainAgitation } from '../components/MenteEnSilencio/PainAgitation';
import { ProductPresentation } from '../components/MenteEnSilencio/ProductPresentation';
import { Bonuses } from '../components/MenteEnSilencio/Bonuses';
import { Pricing } from '../components/MenteEnSilencio/Pricing';
import { ComparisonTable } from '../components/MenteEnSilencio/ComparisonTable';
import { Testimonials } from '../components/MenteEnSilencio/Testimonials';
import { WhyCompleteOption } from '../components/MenteEnSilencio/WhyCompleteOption';
import { Guarantee } from '../components/MenteEnSilencio/Guarantee';
import { FAQ } from '../components/MenteEnSilencio/FAQ';
import { FinalCTA } from '../components/MenteEnSilencio/FinalCTA';
import { Footer } from '../components/MenteEnSilencio/Footer';
import { FloatingNotification } from '../components/FloatingNotification';
import { MobileHero } from '../components/MenteEnSilencio/MobileHero';
export function LandingPage() {
  return <div className="min-h-screen bg-[#FAF0E6] selection:bg-gold/30" data-id="element-622">
      <noscript data-id="element-623">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1313291250496067&ev=PageView&noscript=1" data-id="element-624" />
      </noscript>

      <FloatingNotification data-id="element-625" />
      <div className="flex flex-col" data-id="element-626">
        <MobileHero data-id="element-627" />
        <Stats data-id="element-628" />
        <HeroTestimonials data-id="element-629" />
        <PainAgitation data-id="element-630" />
        <ProductPresentation data-id="element-631" />
        <Bonuses data-id="element-632" />
        <Pricing data-id="element-633" />
        <ComparisonTable data-id="element-634" />
        <Testimonials data-id="element-635" />
        <WhyCompleteOption data-id="element-636" />
        <Guarantee data-id="element-637" />
        <FAQ data-id="element-638" />
        <FinalCTA data-id="element-639" />
        <Footer data-id="element-640" />
      </div>
    </div>;
}